/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import { UserMin } from '@g17eco/types/user';

export enum MessageType {
  Survey = 'survey',
  BulkSurvey = 'bulkSurvey',
  Question = 'question',
  User = 'user',
}

export enum MessageFormField {
  UserIds = 'userIds',
  ContributorIds = 'contributorIds',
  VerifierIds = 'verifierIds',
  Subject = 'subject',
  Message = 'message',
  SendByEmail = 'sendByEmail',
}

export interface MessageFormFields {
  [MessageFormField.UserIds]: string[];
  [MessageFormField.ContributorIds]: string[];
  [MessageFormField.VerifierIds]: string[];
  [MessageFormField.Subject]: string;
  [MessageFormField.Message]: string;
  [MessageFormField.SendByEmail]: boolean;
  surveyId?: string;
  utrvId?: string;
}

export type OnChangeInterface = (property: string) => (value: string | boolean | string[]) => void;

export interface MessageFormProps {
  form: MessageFormFields;
  onChange: OnChangeInterface;
}

export interface MessagePayload extends MessageFormFields {
  type: MessageType;
}

export interface RequesterMessageFormFields {
  [MessageFormField.Subject]: string;
  [MessageFormField.Message]: string;
  [MessageFormField.SendByEmail]: boolean;
}

export type MessageFormUserMin = Pick<UserMin, '_id' | 'firstName' | 'surname'>;
